<div class="container-fluid main-content mt-5 pt-5 col-lg-10 col-md-10 col-12">
  <div class="custom-card">
    <div class="card-body">
      <h1 class="custom-card-title text-left">My Drafts</h1>
      <p class="text-muted">Manage your saved project drafts</p>

      <div *ngIf="loading" class="text-center py-4">
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>

      <div *ngIf="!loading && drafts.length === 0" class="alert alert-info">
        <i class="bi bi-info-circle"></i>
        You don't have any saved drafts yet.
      </div>

      <div *ngIf="!loading && drafts.length > 0" class="row">
        <div class="col-12">
          <div class="table-responsive">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th>Title</th>
                  <th>School</th>
                  <th>Last Modified</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let draft of drafts">
                  <td>
                    <strong>{{ draft.title || 'Untitled Draft' }}</strong>
                  </td>
                  <td>{{ draft.school || 'Not specified' }}</td>
                  <td>{{ formatDate(draft.dateEdited) }}</td>
                  <td>
                    <button 
                      class="btn btn-primary btn-sm me-2" 
                      (click)="editDraft(draft)"
                      title="Continue editing this draft">
                      <i class="bi bi-pencil"></i> Edit
                    </button>
                    <button 
                      class="btn btn-danger btn-sm" 
                      (click)="deleteDraft(draft)"
                      title="Delete this draft">
                      <i class="bi bi-trash"></i> Delete
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="mt-4">
        <a href="/new-project" class="btn btn-success">
          <i class="bi bi-plus-circle"></i> Create New Project
        </a>
      </div>
    </div>
  </div>
</div>